export default __webpack_public_path__ + "static/no-pets-dadf4c7314e71f31d3d0f4e5dd67e82d.png";